import { useEffect } from 'react';
import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import FeaturedSection from './components/FeaturedSection';
import LatestSection from './components/LatestSection';

export default function Home() {
  useEffect(() => {
    const existingScript = document.getElementById('schema-home');
    if (existingScript) {
      existingScript.remove();
    }
    const schemas = [
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: '91片库 - 海量高清资源免费在线观看',
        url: 'https://www.91piianku.com',
        description: '91片库是您最值得信赖的在线影视资源平台，汇聚海量高清电影、电视剧、综艺及短视频内容。',
        isPartOf: { '@type': 'WebSite', name: '91片库', url: 'https://www.91piianku.com' },
        inLanguage: 'zh-CN',
      },
    ];
    const script = document.createElement('script');
    script.id = 'schema-home';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schemas);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById('schema-home');
      if (el) el.remove();
    };
  }, []);

  return (
    <main>
      <HeroBanner />
      <CategoryNav />
      <FeaturedSection />
      <LatestSection />
    </main>
  );
}